import React, { Component } from 'react';
import { TabCard, Button } from '@cimpress/react-components';

export default class TabCardDemo extends Component {
  state = { selectedIndex: 1 };

  setLastTab = () => this.setState({ selectedIndex: 2 });

  updateSelectedTab = (e, selectedKey) => this.setState({ selectedIndex: selectedKey });

  render() {
    const tabBody = <div>Lorem ipsum dolor sit amet</div>;
    const tabBody2 = <div>consectetur adipiscing elit</div>;
    const tabBody3 = <div>sed do eiusmod tempor</div>;

    const footer2 = <div> I am a footer </div>;
    const footer3 = <div> I am a different footer </div>;

    const tabs = [
      {
        name: 'Tab 1',
        block: tabBody,
        href: '#',
      },
      {
        name: 'Default SelectedTab',
        block: tabBody2,
        footer: footer2,
        href: '#',
      },
      {
        name: 'Tab 3',
        block: tabBody3,
        footer: footer3,
        href: '#',
      },
    ];

    return (
      <div>
        <TabCard tabs={tabs} selectedIndex={this.state.selectedIndex} onSelect={this.updateSelectedTab} />
        <Button onClick={this.setLastTab}>Select last tab</Button>
      </div>
    );
  }
}
